/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { KEYBOARD_NAV_DATA_ID as i, tableKeyboardNavigationTools as a } from "@progress/kendo-react-data-tools";
import { classNames as n, uGrid as c } from "@progress/kendo-react-common";
import { GridContext as l } from "../../GridClientWrapper.mjs";
const m = (s) => {
  const r = t.useContext(l), e = r.headerRef.current, d = e && e.table() && e.table().clientWidth, o = c;
  return /* @__PURE__ */ t.createElement("div", { key: "no-records", className: n(o.noRecords({})), style: { width: d } }, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: n(o.noRecordsTemplate({})),
      [i]: a.generateNavigatableId(
        "no-records",
        a.getIdPrefix(r.navigationStateRef)
      )
    },
    s.children
  ));
};
m.displayName = "KendoReactGridNoRecordsContainer";
export {
  m as GridNoRecordsContainer
};
